import {
    DISTRICTLISTAGENTFORPARTNER_SUCCESS,
    DISTRICTLISTAGENTFORPARTNER_FAILED,
    RESET_DISTRICTLISTAGENTFORPARTNER,
    LOADING_DISTRICTLISTAGENTFORPARTNER,
    NETWORK_ERROR_DISTRICTLISTAGENTFORPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetDISTRICTLISTAGENTFORPARTNER = () => {
    return { type: RESET_DISTRICTLISTAGENTFORPARTNER };
};

const partnerDistrictListReq = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DISTRICTLISTAGENTFORPARTNER });
    await partnerServices
        .post("districtList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerDistrictListReqsuccess(res.data));
                    break;
                default:
                    dispatch(partnerDistrictListReqFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DISTRICTLISTAGENTFORPARTNER,
                payload: err
            });
        });
};

function partnerDistrictListReqsuccess(data) {
    return {
        type: DISTRICTLISTAGENTFORPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerDistrictListReqFailed(data) {
    return {
        type: DISTRICTLISTAGENTFORPARTNER_FAILED,
        payload: data,
    };
}

export { resetDISTRICTLISTAGENTFORPARTNER, partnerDistrictListReq }